import React, { FC } from 'react';
import classes from './index.module.css';

const NotFound: FC = (): JSX.Element =>
	<div className={classes.root}>
		<h1>Page not found</h1>
	</div>;

export default NotFound;
